import { createContext } from 'react';

export interface ProjectDataContextType {
    refetchProjects: () => Promise<void>;
    setRefetchProjects: (refetchFn: () => Promise<void>) => void;
}

export const ProjectDataContext = createContext<ProjectDataContextType | null>(
    null
);
